(function() {
  'use strict';

  angular
    .module('ppt.pptImageDirective', ['ppt.pptImageCtrl', 'factories.mobileHelper'])
    .directive('mfPptImage', mfPptImage);

  mfPptImage.$inject = ['MobileHelper', '$window', '$timeout', 'Utils'];

  function mfPptImage(MobileHelper, $window, $timeout, Utils) {
    return {
      link: function(scope, element) {
        var pptImageElement = element.find('.pptImageSlide');
        var win = $($window);

        var resizeThrottle = _.throttle(onResize, 250);
        var w, h, maxHeight, maxWidth;
        var padding = { w: 100, h: 100 };

        var preloadImage = new Image();
        preloadImage.onload = function() {
          preloadImage.onload = null;
          preloadImage = null;
          $timeout(scope.showSlide);
        };
        preloadImage.src = scope.pptImageInfo.contentPath;

        function onResize() {
          // Do this in a timeout to ensure the size/position of the hyperlinks is updated via angular.
          // In the future we may want to move all of the resizing of hyperlinks outside of angular too.
          // This will make the resize visually faster.
          $timeout(function() {
            maxHeight = win.height() - padding.w;
            maxWidth = win.width() - padding.h;

            w = scope.pptImageInfo.width;
            h = scope.pptImageInfo.height;

            if (MobileHelper.isIpad() && MobileHelper.isNativeIpadApp) {
              // Make it take the full screen.
              h = maxHeight;
              w = maxHeight / scope.pptImageInfo.height * scope.pptImageInfo.width;
            }

            var scaleX = maxWidth / w;
            var scaleY = maxHeight / h;
            var scaler = Math.min(scaleX, scaleY);

            if (scaler < 1) {
              w = Math.round(w * scaler);
              h = Math.round(h * scaler);
            }

            pptImageElement.css({
              width: w,
              height: h
            });

            element.css({ width: w });
          });
        }

        if (MobileHelper.isIpad() && MobileHelper.isNativeIpadApp) {
          //Make it take the full screen.
          padding = { w: 0, h: 0 };
        }

        onResize();

        angular.element($window).on('resize', resizeThrottle);

        scope.getPptImageHyperlinkStyle = function(link) {
          if (!link) return;

          var naturalHeight = scope.pptImageInfo.height;
          var naturalWidth = scope.pptImageInfo.width;
          var currentHeight = element.height();
          var currentWidth = element.width();

          return {
            height: Math.round((link.height / naturalHeight) * currentHeight),
            width: Math.round((link.width / naturalWidth) * currentWidth),
            left: Math.round((link.x / naturalWidth) * currentWidth),
            top: Math.round((link.y / naturalHeight) * currentHeight)
          };
        };

        scope.pptImageHyperlinkClicked = function(url) {
          Utils.viewUrl(url);
        };

        scope.$on('$destroy', function() {
          angular.element($window).off('resize', resizeThrottle);
          if (preloadImage) {
            preloadImage.onload = null;
            preloadImage = null;
          }
        });
      }
    }
  }
})();
